export default __webpack_public_path__ + "static/media/github.bd38ba62.webp";